import styled from "styled-components";

export const DashboardContentBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const DashboardTitBox = styled.div<{ spaceBetween?: boolean }>`
  width: 100%;
  display: flex;
  min-height: 28px;
  padding: 0 4px;
  font-size: 1.9rem;
  font-weight: 600;
  justify-content: ${(props) => (props.spaceBetween ? "space-between" : "")};
  align-items: center;
  flex-wrap: wrap;
  gap: 8px 16px;
`;

export const DashboardShipOperationDividerLine = styled.div`
  width: 1px;
  height: 12px;
  background: #00000019;
`;

export const DashboardShipOperationBox = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
`;

export const DashboardShipOperationText = styled.p`
  font-size: 1.2rem;
  color: #00000099;
`;

export const DashboardShipOperationCheckBox = styled.div`
  width: 14px;
  height: 14px;
  border: 1px solid #00000049;
  border-radius: 2px;
  background: none;
`;
